import { screenSizeCoefficient } from './breakpoints'

export function updateFontSize() {

  if (window.innerWidth > 1920){

    let fontCoef = window.innerWidth / 1920
    let fontSize = Math.floor(100 * fontCoef)
    $('html').css('font-size', fontSize + '%')

  }

}
